import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import type { Insight } from './types'
import { CategoryVariant } from './insights-section/category-marker'
import {
    InsightSection,
    InsightCategory,
} from './insights-section/insight-section'
import { InsightsTab } from './utils'

const HEADING_ID = 'top-trends-heading'

/**
 * Temporary category mapping based on keywords in the insight title or summary.
 * The backend will eventually return the category directly on each insight.
 */
const CATEGORY_KEYWORDS: { pattern: RegExp; variant: CategoryVariant }[] = [
    { pattern: /online|digital|channel/i, variant: CategoryVariant.Digital },
    { pattern: /district|peer|outpace/i, variant: CategoryVariant.District },
]

const DEFAULT_VARIANT: CategoryVariant = CategoryVariant.Performance

function getCategoryVariantFor(insight: Insight): CategoryVariant {
    const text = `${insight.title} ${insight.summary}`
    const match = CATEGORY_KEYWORDS.find(({ pattern }) => pattern.test(text))
    return match?.variant ?? DEFAULT_VARIANT
}

interface TopTrendsProps {
    insights: Insight[]
}

export const TopTrends = ({ insights }: TopTrendsProps) => {
    const { t } = useEssentials()
    const { insights: insightsKeys } = TRANSLATION_KEYS

    const getCategory = (insight: Insight): InsightCategory => {
        const variant = getCategoryVariantFor(insight)
        return { variant, label: t(insightsKeys.category[variant]) }
    }

    return (
        <InsightSection
            headingId={HEADING_ID}
            heading={t(insightsKeys.topTrendsFromLastWeek)}
            insights={insights}
            tab={InsightsTab.Weekly}
            getCategory={getCategory}
        />
    )
}
